module.exports = __webpack_public_path__ + "img/er.95fba807.png";